<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>员工维护</el-breadcrumb-item>
            <el-breadcrumb-item>员工管理</el-breadcrumb-item>
        </el-breadcrumb>
        <el-card>
            <el-row :gutter="0">
                <el-col :span="10">
                    <el-input placeholder="请输入查询内容" v-model="queryInfo.query" class="input-with-select" clearable
                        style="width:300px " @clear="getyuangongList" @change="getyuangongList">
                        <el-button slot="append" icon="el-icon-search" @click="getyuangongList"></el-button>
                    </el-input>
                </el-col>
                <el-col :span="4">
                    <el-button type="primary" @click="get_yuangong_add" v-if="true">添加员工</el-button>
                </el-col>
            </el-row>
            <el-row :gutter="0" class="el_row_two">
                <el-col :span="24">
                    <el-table :data="yuangongList" style="width: 100%" border stripe>
                        <!-- <el-table-column type="index" label="序号" width="80"></el-table-column> -->
                        <el-table-column prop="uid" label=" 序号" width="auto"></el-table-column>
                        <el-table-column prop="yuangong_bianhao" label=" 编号" width="auto"></el-table-column>
                        <el-table-column prop="juese_name" label="角色" width="auto"></el-table-column>
                        <el-table-column prop="yuangong_name" label="员工名称" width="auto"></el-table-column>
                        <el-table-column prop="yuangong_mob" label="手机" width="auto"></el-table-column>
                        <el-table-column prop="yuangong_addr" label="地址" width="auto"></el-table-column>
                        <!-- <el-table-column prop="yuangong_flag_baiMingdan" label="白名单" width="130"> -->
                        <!-- <template v-slot="scope">
                <div v-if=" scope.row.yuangong_flag_baiMingdan"> 白名单用户 </div> 
                    
              </template>
            </el-table-column> -->
                        <el-table-column prop="add_time" label="加入时间"></el-table-column>
                        <el-table-column label="操作">
                            <template v-slot="scope">
                                <el-tooltip class="item" effect="dark" content="修改" placement="top" :enterable="false">
                                    <el-button type="primary" icon="el-icon-edit" @click="showEditDialog(scope.row.uid)"
                                        circle size="mini"></el-button>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="删除" placement="top" :enterable="false">
                                    <el-button type="danger" icon="el-icon-delete" circle size="mini"
                                        @click="deleteForm(scope.row.uid)"></el-button>
                                </el-tooltip>
                                <!-- <el-tooltip class="item" effect="dark" content="设置为白名单" placement="top" :enterable="false">
                  <el-button type="danger" icon="el-icon-coordinate" circle size="mini"
                    @click="baiMingdan(scope.row.uid,scope.row.yuangong_flag_baiMingdan)"></el-button>
                </el-tooltip> -->
                                <el-tooltip class="item" effect="dark" content="员工回访" placement="top" :enterable="false"
                                    style="display: none;">
                                    <el-button type="success" icon="el-icon-orange"
                                        @click="showHuifangDialog(scope.row.uid)" circle size="mini"></el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
            <!-- 分页 -->
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page.sync="queryInfo.pageNum" :page-sizes="[10, 50]" :page-size="queryInfo.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="total">
                <!--分页组件，其中handleSizeChange 条数下拉触发事件，  handleCurrentChange  选择分页出发事件 currentPage2 当前页绑定 page-sizes 下拉显示列表 page-size 每页多少条绑定 layout 显示分页的元素 total 合计条数绑定  -->
            </el-pagination>

            <!-- 添加员工部分 -->
            <el-dialog title="添加员工" :visible.sync="addDialogVisible" width="50%" @close="addDoalogClosed">
                <el-form ref="addFormRef" :model="addForm" :rules="addFormRules" label-width="100px">
                    <el-form-item label="员工编号" prop="yuangong_bianhao">
                        <el-input v-model="addForm.yuangong_bianhao" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="员工姓名" prop="yuangong_name">
                        <el-input v-model="addForm.yuangong_name"></el-input>
                    </el-form-item>
                    <el-form-item label="选择角色" prop="juese_uid">
                        <el-select v-model="addForm.juese_uid" placeholder="选择角色" @change="getJueseList">
                            <el-option v-for="item in jueseList" :key="item.uid" :label="item.juese_name"
                                :value="item.uid"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="员工等级" prop="yuangong_level">
                        <el-select v-model="addForm.yuangong_level" placeholder="请选择员工等级">
                            <el-option v-for="item in yuangong_options" :key="item.value" :label="item.label"
                                :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="联系手机号" prop="yuangong_mob">
                        <el-input v-model="addForm.yuangong_mob" max="11" min="10"></el-input>
                    </el-form-item>
                    <el-form-item label="身份证号" prop="yuangong_sfz_bianhao">
                        <el-input v-model="addForm.yuangong_sfz_bianhao" max="18" min="10"></el-input>
                    </el-form-item>
                    <el-form-item label="联系地址" prop="yuangong_addr">
                        <el-input v-model="addForm.yuangong_addr" max="11" min="10"></el-input>
                    </el-form-item>
                    <el-form-item label="员工备注" prop="yuangong_addr">
                        <el-input v-model="addForm.yuangong_memo" max="11" min="10"></el-input>
                    </el-form-item>
                    <el-form-item label="账号" prop="username">
                        <el-input v-model="addForm.username" max="11" min="10"></el-input>
                    </el-form-item>
                    <el-form-item label="登录密码" prop="password">
                        <el-input v-model="addForm.password" max="11" min="10" type="password"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="addDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="addYuangong" :disabled="add_isDisable">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 修改员工信息 -->
            <el-dialog title="修改员工信息" :visible.sync="editDialogVisible" width="50%" @close="editDoalogClosed">
                <el-form ref="editFormRef" :model="editForm" :rules="editFormRules" label-width="100px">
                    <el-form-item label="员工编号" prop="yuangong_bianhao">
                        <el-input v-model="editForm.yuangong_bianhao" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="员工姓名" prop="yuangong_name">
                        <el-input v-model="editForm.yuangong_name"></el-input>
                    </el-form-item>
                    <el-form-item label="选择角色" prop="juese_uid">
                        <el-select v-model="editForm.juese_uid" placeholder="选择角色" @change="getJueseList">
                            <el-option v-for="item in jueseList" :key="item.uid" :label="item.juese_name"
                                :value="item.uid"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="员工等级" prop="yuangong_level">
                        <el-select v-model="editForm.yuangong_level" placeholder="请选择员工等级">
                            <el-option v-for="item in yuangong_options" :key="item.value" :label="item.label"
                                :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="联系手机号" prop="yuangong_mob">
                        <el-input v-model="editForm.yuangong_mob" max="11" min="10"></el-input>
                    </el-form-item>
                    <el-form-item label="身份证号" prop="yuangong_sfz_bianhao">
                        <el-input v-model="editForm.yuangong_sfz_bianhao" max="18" min="10"></el-input>
                    </el-form-item>
                    <el-form-item label="联系地址" prop="yuangong_addr">
                        <el-input v-model="editForm.yuangong_addr" max="11" min="10"></el-input>
                    </el-form-item>
                    <el-form-item label="员工备注" prop="yuangong_addr">
                        <el-input v-model="editForm.yuangong_memo" max="11" min="10"></el-input>
                    </el-form-item>
                    <el-form-item label="账号" prop="username">
                        <el-input v-model="editForm.username" max="11" min="10"></el-input>
                    </el-form-item>
                    <el-form-item label="登录密码" prop="password">
                        <el-input v-model="editForm.password" max="11" min="10" type="password"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="editDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="updateyuangong">确 定</el-button>
                </span>
            </el-dialog>
        </el-card>
    </div>
</template>
<script>
import { checkMobileTest, checkSfzId } from './config/validator';
export default {
    data() {
        return {
            yuangongLy_options: [
                {
                    value: 1,
                    label: '员工介绍'
                },
                {
                    value: 2,
                    label: '回访员工'
                },
                {
                    value: 3,
                    label: '上门员工'
                }
            ],
            yuangong_options: [
                {
                    value: 1,
                    label: '初级员工'
                },
                {
                    value: 2,
                    label: '中级员工'
                },
                {
                    value: 3,
                    label: '高级员工'
                },
                {
                    value: 4,
                    label: '主管'
                },
                {
                    value: 5,
                    label: '总监'
                },
                {
                    value: 6,
                    label: '经理'
                }
            ],
            // 获取用户列表参数
            queryInfo: {
                C_type: 'get_list',
                C_table_name: 'yuangong_list',
                query: '',
                pageNum: 1,
                pageSize: 10,
                qiye_uid: window.sessionStorage.getItem('qiye_uid')
            },
            huifang_isDisable: false,
            add_isDisable: false,
            yuangongList: [],
            xiaoquList: [],
            //  recordCount: 0,
            total: 0,
            addDialogVisible: false,
            editDialogVisible: false,
            huifangDialogVisible: false,

            // 用于设置回访页面滑块值
            //  添加表单数据项
            huifangForm: {
                C_type: 'huifang_add',
                huifang_yuangong_uid: 0,
                huifang_title: '',
                hufiang_memo: '',
                huifang_genjin: 1,
                huifang_switch: true
            },
            addForm: {
                C_type: 'yuangong_add',
                uid: 0,
                yuangong_bianhao: '',
                yuangong_name: '',
                yuangong_mob: '',
                yuangong_addr: '',
                yuangong_sfz_bianhao: '',
                yuangong_level: '',
                yuangong_memo: '',
                username: '',
                password: '123456',
                juese_uid: 56
            },
            // 用于修改数据绑定
            editForm: {},
            jueseList: [],
            // 表单规则项
            addFormRules: {
                yuangong_name: [
                    { required: true, message: '请输入员工名称', trigger: 'blur' },
                    { min: 2, max: 20, message: '必须2到20位字符 ', trigger: 'blur' }
                ],

                yuangong_mob: [
                    {
                        validator: checkMobileTest.bind(
                            this.addForm && this.addForm.yuangong_mob
                        )
                    }
                ],
                yuangong_sfz_bianhao: [
                    {
                        validator: checkSfzId.bind(
                            this.addForm && this.addForm.yuangong_sfz_bianhao
                        )
                    }
                ]
            },

            editFormRules: {

            }
        };
    },
    created() {
        this.getyuangongList()
    },
    methods: {
        async getJueseList() {
            // console.log(123)
            const { data: res } = await this.$http.get('get_api', {
                params: {
                    C_table_name: 'qiye_juese_list', // 调用普通api get接口 2
                    C_type: 'get_list',
                    query: '',
                    pageNum: 1,
                    pageSize: 10
                }
            });
            console.log(res.data)
            this.jueseList = JSON.parse(res.data)[0].dataList
        },
        get_switch_value(switchValue) {
            this.huifangForm.huifang_genjin = switchValue ? 1 : 0;
            console.log(this.huifangForm.huifang_genjin);
        },
        async huiFangAdd() {
            const { data: res } = await this.$http.post('api', this.huifangForm);
            console.log(JSON.parse(res.data)[0].bianhao_s);
            this.huifangDialogVisible = true;
        },
        async get_yuangong_add() {
            const { data: res } = await this.$http.get('get_api', {
                params: { C_type: 'get_bianhao', C_table_type: 19 }
            });
            console.log(JSON.parse(res.data)[0].bianhao_s);
            this.addForm.yuangong_bianhao = JSON.parse(res.data)[0].bianhao_s;
            this.addForm.username = JSON.parse(res.data)[0].bianhao_s;

            this.getJueseList()
            
            // this.total = JSON.parse(res.data)[0].total
            this.addDialogVisible = true;
        },

        async getyuangongList() {
            const { data: res } = await this.$http.get('get_api', {
                params: this.queryInfo
            });
            console.log(JSON.parse(res.data)[0].dataList)
            this.yuangongList = JSON.parse(res.data)[0].dataList

            if (!this.yuangongList) return;
            this.yuangongList.forEach(function (item) {
                item.yong_flag = item.yong_flag === 1;
            });

            this.total = JSON.parse(res.data)[0].total;

            // console.log(this.total)
        },
        //  分页第一项下拉触发

        handleSizeChange(newSize) {
            this.queryInfo.pageSize = newSize;
            this.getyuangongList();
        },
        // 选择页数触发
        handleCurrentChange(newPage) {
            this.queryInfo.pageNum = newPage;
            this.getyuangongList();
        },

        async addYuangong() {
            this.$refs.addFormRef.validate(async valid => {
                if (!valid) return 1;
                this.add_isDisable = true
                setTimeout(() => {
                    this.add_isDisable = false // 点击一次时隔两秒后才能再次点击
                }, 2000)
                const { data: res } = await this.$http.post('api', this.addForm);
                console.log(JSON.parse(res.data)[0].status);
                if (JSON.parse(res.data)[0].status === 201) {
                    this.$message.error('手机号码重复')
                    return
                } else if ((JSON.parse(res.data)[0].status !== 200) && (JSON.parse(res.data)[0].status !== 201)) {
                    this.$message.error('添加失败')
                    return
                }
                this.$message.success('添加成功');
                this.getyuangongList();
                this.addDialogVisible = false;
            });
        },

        showEditDialog(uid) {
            this.yuangongInfo(uid);
            this.getyuangongList()
            this.getJueseList()
            this.editDialogVisible = true;
        },
        addDoalogClosed() {
            console.log('test', this.addDialogVisible)
            this.$refs.addFormRef.resetFields();
        },
        huifangDoalogClosed() {
            this.$refs.huifangFormRef.resetFields();
        },
        showHuifangDialog(uid) {
            this.huifangDialogVisible = true;
            this.yuangongInfo(uid);
        },
        editDoalogClosed() {
            this.$refs.editFormRef.resetFields();
        },
        async yuangongInfo(uid) {
            const { data: res } = await this.$http.get('get_api', {
                params: { C_table_name: 'yuangong_info', uid: uid, C_type: 'get_info' }
            });
            // console.log(JSON.parse(res.data))
            console.log(res.data);
            if (JSON.parse(res.data)[0].status !== 200) {
                return this.$message.error('读取失败');
            }

            this.editForm = JSON.parse(res.data)[0].data[0];
            console.log(110, this.editForm)
            // this.huifangForm.huifang_yuangong_uid = JSON.parse(res.data)[0].data[0].uid;
        },
        async updateyuangong() {
            this.$refs.editFormRef.validate(async valid => {
                if (!valid) return this.$message.error('验证错误！');
                // 对象加入一个项C_type
                const { data: res } = await this.$http.post('api', {
                    C_type: 'yuangong_update',
                    yuangong_uid: this.editForm.uid,
                    yuangong_name: this.editForm.yuangong_name,
                    yuangong_mob: this.editForm.yuangong_mob,
                    yuangong_addr: this.editForm.yuangong_addr,
                    yuangong_sfz_bianhao: this.editForm.yuangong_sfz_bianhao,
                    yuangong_level: this.editForm.yuangong_level,
                    yuangong_memo: this.editForm.yuangong_memo,
                    username: this.editForm.username,
                    password: this.editForm.password,
                    juese_uid: this.editForm.juese_uid
                });
                if (JSON.parse(res.data)[0].status !== 200) {
                    this.$message.error('更新失败');
                    return;
                }
                this.$message.success('更新成功');
                this.getyuangongList();
                this.editDialogVisible = false;
            });
        },
        async deleteForm(yuangongUid) {
            // 此处通过异步获取操作行为，而不用then ，来避免异步嵌套
            // 异步操作有2个，1个对话框等待，1个是网络请求
            const comfirmResult = await this.$confirm(
                '确定删除该条记录, 是否继续?',
                '提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }
            ).catch(err => err);
            console.log(comfirmResult);
            if (comfirmResult === 'cancel') return this.$message.info('已经取消删除');
            const { data: res } = await this.$http.post('api', {
                C_type: 'record_delete',
                C_table_name: 'yuangong_del',
                C_data1: yuangongUid
            });
            if (JSON.parse(res.data)[0].status !== 200) {
                this.$message.error('删除失败');
                return;
            }
            this.$message.success('删除成功');
            this.getyuangongList();
        },

        // 设置白名单
        async baiMingdan(yuangongUid, baiMingdanFlag) {
            // 此处通过异步获取操作行为，而不用then ，来避免异步嵌套
            // 异步操作有2个，1个对话框等待，1个是网络请求
            var flag = 0
            if (baiMingdanFlag) flag = 0
            else flag = 1
            const comfirmResult = await this.$confirm(
                '确定要设置为白名单吗, 是否继续?',
                '提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }
            ).catch(err => err);
            console.log(comfirmResult);
            if (comfirmResult === 'cancel') return this.$message.info('已经取消删除');

            const { data: res } = await this.$http.post('api', {
                C_type: 'yuangong_baiMingdan',
                yuangongUid: yuangongUid,
                baiMingdanFlag: flag
            });
            if (JSON.parse(res.data)[0].status !== 200) {
                this.$message.error('设置失败');
                return;
            }
            this.$message.success('设置成功');
            this.getyuangongList();
        }
    }
};
</script>
<style lang="less" scoped>
.card_two {
    margin-top: 30px;
    box-shadow: none !important;
    background-color: #f2f6fc;
}

.el_row_two {
    margin-top: 30px;
}
</style>
